import React, { Component } from 'react'
import logo from "../../assets/logo_espol_interno.svg";
import check from "../../assets/check.svg";
import checkGreen from "../../assets/check.png";
import equis from "../../assets/eliminar.svg"
import Modal from './Modal';
import axios from "axios";
import "../../css/FormRegistroContrasenia.css"
import ComponenteContrasenia from './ComponenteContrasenia';
import { Navigate } from 'react-router-dom';
import Header from '../components/Header.js'
import Footer from '../components/Footer.js'
import CenteredWrapper from '../components/CenteredWrapper.js';
import BotonExpandible from "../components/BotonExpandible";
import Acuerdo from './Acuerdo.js'
import anuncioico from "../../assets/AnuncioICO.svg";


export class FormRegistroContrasenia extends Component {

    constructor(props) {
        super(props);

        this.state = {
            IsFirmadoElect: this.props.IsFirmadoElect,
            verAcuerdo: false,
            showPassword: false,
            showRepetirPassw: false,
            modalIsOpen: false,
            activebutton: true,
            datosUsuario: {
                id: this.props.id,
                nombres: this.props.nombres,
                apellidos: this.props.apellidos,
                identificacion: this.props.identificacion,
                alias_sugerido: this.props.alias_sugerido,
                usuarioEscogido: this.props.usuario_sugerido,
                correoAlterno: this.props.correoAlterno,
                rol: this.props.rol,
                telefono: this.props.telefono,
                unidad: this.props.unidad,
                idAcueFirmElec: this.props.idAcFirmaElec,
                tipoForm: this.props.tipoForm,
                fotoRostro: this.props.fotoRostro,
                fotoCedula: this.props.fotoCedula,
            },
            contra: {
                contrasena: "",
                contrasenaCumple: false,
                repetirContraCumple: false,
                terminos: ""
            },
            expresiones: {
                contrasena: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@*._-]{10,12}$/,
            },
            modalError: false,
            modalErrorMensaje: "",
            renderNavigateLogin: false,
            token_nueva_cuenta: sessionStorage.getItem("token_nueva_cuenta")
        };
        this.abrirModalInfo = this.abrirModalInfo.bind(this);
        this.cerrarModalInfo = this.cerrarModalInfo.bind(this);
        this.cambiarEstado = this.cambiarEstado.bind(this);

        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.renderRegistro = this.renderRegistro.bind(this);
        this.abrirAcuerdo = this.abrirAcuerdo.bind(this);


        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);
    }

    componentWillMount() {
        this.agregarNombresEnRegla();
        /*this.props.useEffect();*/
        //console.log(this.props.fotoCedula);
        //console.log(this.props.fotoRostro);
    }
   

    agregarNombresEnRegla() {
        var nombreString = "";
        var nombres = this.state.datosUsuario.nombres.split(" ");
       // var nombres_temp = nombres.split(" ");
        var apellidos = this.state.datosUsuario.apellidos.split(" ");
       // var apellidos_temp = apellidos.split(" ");

        var nombreCompleto = nombres.concat(apellidos);

        for (var i = 0; i < nombreCompleto.length; i++) {
            if (i == nombreCompleto.length - 1) {
                nombreString = nombreString.concat(nombreCompleto[i]);
            } else {
                nombreString = nombreString.concat(nombreCompleto[i] + ", ");
            }
        }
        this.setState({
            nombresRegla: nombreString
        })
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });

    }

    abrirModalError() {
        this.setState({ modalError: true });
    }

    cerrarModalError() {
        this.setState({ modalError: false })
    }

    abrirModalInfo() {
        this.setState({ modalIsOpen: true });
    }

    cerrarModalInfo() {
        this.setState({ modalIsOpen: false });
        this.setState({ renderNavigateLogin: true })
    }

    abrirAcuerdo() {
        this.setState({ verAcuerdo: true });
        //console.log("Ver Acuerdo");
    }


    handlerDatosFormRegistro = async (e) => {
        await this.setState({
            contra: {
                ...this.state.contra,
                [e.target.name]: e.target.value,
                terminos: e.target.checked
            }
        })
        //console.log(this.state.contra);
    }

  cambiarEstado(contrasenaactual,valor, contraCumple, repetirContraCumple) {
        this.setState({
            contra: {
                ...this.state.contra,
                contrasena: valor,
                contrasenaCumple: contraCumple,
                repetirContraCumple: repetirContraCumple
            }
        })
       // console.log("CAMBIAR ESTADO");
        //console.log(this.state.contra);
        //console.log(this.state.datosUsuario);
    }

    renderRegistro(e) {
        e.preventDefault();
        this.props.renderFormRegistro(false);
       // console.log("cambio form registro contraseña");
    }



    postCrearCuenta = async (e) => {
        this.props.callTagManager("click-btn-crear-cuenta");
        e.preventDefault();
        this.disabledbuttonf();
        
        var crearCuenta = {
            alias: this.state.datosUsuario.alias_sugerido,
            username: this.state.datosUsuario.usuarioEscogido,
            nombres: this.state.datosUsuario.nombres,
            apellidos: this.state.datosUsuario.apellidos,
            identificacion: this.state.datosUsuario.identificacion,
            personaId: this.state.datosUsuario.id,
            password: this.state.contra.contrasena,
            correoAlterno: this.state.datosUsuario.correoAlterno,
            rol: this.state.datosUsuario.rol,
            telefono: this.state.datosUsuario.telefono,
            unidad: this.state.datosUsuario.unidad,
            isActive: true,
            idDocFirmadoElectronicamente: this.state.datosUsuario.idAcueFirmElec,
            isacuerddig: true
        }
        if( this.state.datosUsuario.tipoForm == "A"){
            crearCuenta.isacuerddig=false;  
        }
       // console.log(crearCuenta);
        //DENTRO DE API/CUENTAUSUARIO DEBO GUARDAR EL REGISTRO EN LA TABLA T_ACUERDO_MEDELECT_DATPERS PARA USUARIOS DE BASE QUE CREAN CUENTA. (FIRMA MANUAL O ELECTRÓNICA)
        axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario`, crearCuenta, {
                headers: {
                    Authorization: `Bearer ${this.state.token_nueva_cuenta}`
                }
            })
            .then(resp => {
                if (resp.status === 200) {
                    /*CREAR LA SOLICITUD SI SE CREA LA CUENTA SOLO PARA TIPOFORM="A"*/
                    if (this.state.datosUsuario.tipoForm == "A") {
                        var datoscuenta = {
                            identificacion: this.state.datosUsuario.identificacion,
                            nombres: this.state.datosUsuario.nombres,
                            apellidos: this.state.datosUsuario.apellidos,
                            telefono: this.state.datosUsuario.telefono,
                            actividad: this.state.datosUsuario.rol,
                            unidad: this.state.datosUsuario.unidad,
                            correo: this.state.datosUsuario.correoAlterno,
                            usuario_sugerido: this.state.datosUsuario.usuarioEscogido,
                            alias_sugerido: this.state.datosUsuario.alias_sugerido,
                            idAcueFirmElec: this.state.datosUsuario.idAcueFirmElec,
                        }
                        //guardar el registro en la tabla IDACUERDOMEDELECTDATPERS
                        var DataJson = JSON.stringify(datoscuenta);
                        
                        var solicitud = {
                            estado: "No Revisado CC",
                            identificacion: this.state.datosUsuario.identificacion,
                            infoSolicitud: DataJson,
                            Motivo: "Solicitud a espera de revisión",
                            fotoimgRostro: this.state.datosUsuario.fotoRostro,
                            fotoimgCedula: this.state.datosUsuario.fotoCedula,
                            filePdf: this.state.pdfData,
                            tipoAcuerdo: "M"
                        }
                        if (!this.state.IsFirmadoElect) {
                                axios.post(`${process.env.REACT_APP_API}api/Solicitud`, solicitud, {
                                    headers: {
                                        Authorization: `Bearer ${this.state.token_nueva_cuenta}`
                                    }
                                })
                                .then(resp => {
                                    this.abrirModalInfo();
                                }).catch(error => {
                                    if (error.response && error.response.status === 401) {
                                        this.setState({
                                            modalError: {
                                                show: true,
                                                titulo: "Error con validación del token",
                                                mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                                                imagen: equis,
                                            }
                                        });
                                    } else if (error.response.data.errorMessage = "Captcha invalido.") {
                                        this.setState({
                                            modalError: {
                                                show: true,
                                                titulo: "Error con validación del captcha",
                                                mensaje: error.response.data.errorMessage,
                                                imagen: equis,
                                            }
                                        });
                                    } else {
                                        this.setState({
                                            modalError: {
                                            show: true,
                                            titulo: "Error en el envio de solicitud",
                                            mensaje: "Exisito un problema al enviar la solicitud",
                                            imagen: equis,
                                            }
                                        });
                                    }
                                    this.activebuttonf(); 
                                })
                        } else {
                            this.abrirModalInfo();
                        }
                    }
                } else {
                    this.abrirModalError();

                }
                this.activebuttonf();
            }).catch(error => {
                this.abrirModalError();
               //console.log(error.message);
                this.activebuttonf();
            })



    }


    render() {
      //console.log(this.state.contra);
      //console.log(this.state.activebutton);
        return (
            this.state.renderNavigateLogin ? <Navigate to="/inicio" /> :
                (<div>
                    {/*<Header />*/}
                    <CenteredWrapper>
                        <div className="registroContra-container">
                            <form >
                               
                                <div className="row">

                                    <BotonExpandible 
                                        mensaje={
                                        <div className=" col-xl-12 ">
                                            <p className="text-justify-center">
                                                <b>REGLAS QUE DEBE CUMPLIR LA CONTRASEÑA:</b>
                                            </p>
                                            <ul>
                                                <li>Tener mínimo 10 caracteres y máximo 12.</li>
                                                <li>Tener al menos una letra minúscula.</li>
                                                <li>Tener al menos una letra mayúscula.</li>
                                                <li>Tener al menos un número.</li>
                                                <li>Solo permite lo siguientes caracteres especiales: @ , * , . , _ , - </li>
                                                <li>La contraseña no puede ser similar al usuario: {this.state.datosUsuario.usuarioEscogido}. </li>
                                                <li>La contraseña no puede contener las siguientes palabras: {this.state.nombresRegla }.</li>

                                            </ul>
                                        </div>
                                        }
                                    />

                                    {/* <div className=" col-sm-2 col-xl-2"></div>
                                    <div id="registroContra-reglas" className="col-sm-8 col-xl-8">
                                        <div className="row">
                                            <div className="col-2 col-sm-2 col-xl-1" >
                                                <img className="registroContra-img" src={anuncioico} alt="crearcuenta" />
                                            </div>
                                            <div className="col-10 col-sm-6 col-xl-6" align="left">
                                                <p className="registroContra-textAviso"><b>PARA SU CONOCIMIENTO</b></p>
                                            </div>
                                        </div>
                                        <div className="row registroContra-padding">
                                            <div className=" col-xl-12 ">
                                                <p className="text-justify-center">
                                                    <b>Es importante que su contraseña cumpla con las siguientes reglas:</b>
                                                </p>
                                                <ul>
                                                    <li>Tener mínimo 10 caracteres y máximo 12.</li>
                                                    <li>Tener al menos una letra minúscula.</li>
                                                    <li>Tener al menos una letra mayúscula.</li>
                                                    <li>Tener al menos un número.</li>
                                                    <li>Solo permite lo siguientes caracteres especiales: @ ,* ,. ,_ ,-</li>
                                                    <li>La contraseña no puede ser similar al usuario: {this.state.datosUsuario.usuarioEscogido}.</li>
                                                    <li>La contraseña no puede contener las siguientes palabras: {this.state.nombresRegla}.</li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>





                                <br />
                                <div className="row-datos-usuario">
                                    {/* <div className="col-12 col-md-2 col-lg-2 col-xl-2">

                                    </div> */}
                                    <div className="">
                                        <label id="registroContra-textoLabel">Usuario: </label>
                                        <input className="form-control" type="text" name="usuarioEscogido" defaultValue={this.state.datosUsuario.usuarioEscogido} disabled />
                                    </div>
                                    {/* <div className="col-12 col-md-1 col-lg-2 col-xl-2">

                                    </div> */}
                                    <div className="">
                                        <label id="registroContra-textoLabel">Alias sugerido: </label>
                                        <label className="sr-only" htmlFor="inlineFormInputGroupUsername"></label>
                                        <div className="input-group">
                                            <input type="text" className="form-control" id="inlineFormInputGroupUsername" name="alias_sugerido" defaultValue={this.state.datosUsuario.alias_sugerido} disabled />
                                            <div id="registroContra-textoLabel" className="input-group-text">@espol.edu.ec</div>
                                        </div>
                                    </div>
                                    {/* <div className="col-12  col-xl-2">

                                    </div> */}
                                </div>
                                <br />

                                <div className="row">
                                    <div className="col-md-2">
                                    </div>
                                    <div className="col-md-8">
                                    <ComponenteContrasenia
                                        cambiarEstado={this.cambiarEstado}
                                        columnas="col-md-8 col-xl-6"
                                        expresionRegular={this.state.expresiones.contrasena}
                                        nombres={this.state.datosUsuario.nombres}
                                        apellidos={this.state.datosUsuario.apellidos}
                                        usuario={this.state.datosUsuario.usuarioEscogido}
                                        isUpdateePss={false}
                                    >
                                    </ComponenteContrasenia>
                                    </div>
                                    <div className="col-md-2">
                                    </div>

                                </div>
                                <br />
                                <div className="registroContra-container-botonGuardar">
                                    <button
                                        type="submit"
                                        disabled={this.state.contra.contrasena &&
                                            this.state.contra.contrasenaCumple &&
                                            this.state.contra.repetirContraCumple && this.state.activebutton ? false : true}
                                        className={this.state.contra.contrasena &&
                                            this.state.contra.contrasenaCumple &&
                                            this.state.contra.repetirContraCumple && this.state.activebutton ?
                                            "registroContra-btn-submit" : "registroContra-btn-submit-disabled"}
                                        onClick={this.postCrearCuenta}>GUARDAR
                                    </button>

                                    {!this.state.activebutton ?
                                        <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                        : null}

                                </div>
                            </form>
                        </div>
                    </CenteredWrapper>
                    


                    <Footer />
                    {this.state.modalIsOpen &&
                        <Modal isOpen={this.state.modalIsOpen} cerrarModal={this.cerrarModalInfo} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>Cuenta creada exitosamente</strong></p>
                            <div align="center" className='mt-6 mb-6'>
                                <img className="registroContra-check" src={checkGreen} alt="Exitoso"></img>
                            </div>

                            <p className='text-center'><strong>¡Gracias por finalizar el formulario!</strong></p>
                            <p className='text-center'>Le comunicamos que luego de 1 hora su cuenta electrónica se encontrará lista para ser utilizada. Una vez culminado el tiempo, usted podrá acceder a beneficios como uso de la plataforma Office365, correo electrónico, acceso a la red inalámbrica.</p>
                            <p className='text-center'>El siguiente enlace le permitirá hacer uso de su correo electrónico cuando culmine el tiempo de espera:
                                <a
                                    href="https://sts.espol.edu.ec/adfs/ls/?cbcxt=&popupui=&vv=&username=&mkt=&lc=&wfresh=&wa=wsignin1.0&wtrealm=urn:federation:MicrosoftOnline&wctx=bk%3D1387224687%26LoginOptions%3D3"
                                    className='registroContra-vinculo'
                                    target="_blank"
                                    rel="noopener noreferrer">clic aquí</a>
                            </p>
                        </Modal>}

                    {this.state.modalError &&
                        <Modal isOpen={this.state.modalError} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>Error en la Solicitud</strong></p>
                            <div className='mt-3 mb-3' align="center">
                                <img className="registroContra-check" src={equis} alt="Error"></img>
                            </div>

                            <p className='text-center'>Error en la solicitud, intentelo mas tarde</p>

                        </Modal>}
                </div>)
        )
    }
}

export default FormRegistroContrasenia
